export const getUserRole = (state) => state.userData.userInfo;

export const getLeftPostalOperators = (state) => state.left.nodes;
export const getLeftCheckedMailProcessingCenters = (state) => state.left.checkedMailProcessingCenters;
export const getLeftCheckedPostalOperators = (state) => state.left.checkedPostalOperators;
export const getLeftExpandedPostalOperators = (state) => state.left.expandedPostalOperators;

export const getRightPostalOperators = (state) => state.right.nodes;
export const getRightCheckedMailProcessingCenters = (state) => state.right.checkedMailProcessingCenters;
export const getRightCheckedPostalOperators = (state) => state.right.checkedPostalOperators;
export const getRightExpandedOperators = (state) => state.right.expandedAllOperators;

export const getInboundImpcsOfSingleOperator = (state) => state.impcsOfSingleOperator.inboundImpcs;
export const getOutboundImpcsOfSingleOperator = (state) => state.impcsOfSingleOperator.outboundImpcs;

export const getLeftPostalOperatorsCodesOnly = (state) => {
  const mappedList = [];
  state.left.nodes.map((node) => {
    const operator = {
      label: node.value,
      value: node.value,
      children: node.children,
    };
    return mappedList.push(operator);
  });
  return mappedList;
};
